import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const CashPlus: FC<IconSVGComponentProps> = (props) => {
    return (
        <IconSVG viewBox="0 0 15 15" {...props}>
            <path
                d="M4.35642 1.84542C4.54233 1.3388 5.02754 1.00451 5.56714 1.01126L13.1007 1.10543C13.5397 1.11091 13.8414 1.54881 13.6902 1.96097L9.64358 12.9879C9.45767 13.4945 8.97246 13.8288 8.43286 13.8221L0.899289 13.7279C0.460283 13.7224 0.158584 13.2845 0.309837 12.8724L4.35642 1.84542Z"
                fill="#62CA6B"
                strokeWidth="0"
            />
        </IconSVG>
    );
};
